import React from 'react';
import { Button, Divider, Flex, Heading } from '@zillow/constellation';
import { useIdVerificationCallbacks, useIsOnExitLoading } from '../contexts/IdVerificationContext';
import { ExitReason } from '../../../models';

export default function IdvHeader({ ...headerProps }) {
  const { onExit } = useIdVerificationCallbacks();
  const isOnExitLoading = useIsOnExitLoading();
  return (
    <header {...headerProps}>
      <Flex display="flex" marginY="sm" marginX={{ default: 'xl', md_lte: 'sm' }} justifyContent="space-between">
        <Flex display="flex" alignItems="center">
          <Heading marginRight="sm" level={5} as="h1">
            Identity verification
          </Heading>
        </Flex>
        <Button
          buttonType="tertiary"
          onClick={() =>
            onExit({
              reason: ExitReason.ModalClose,
              success: false,
            })
          }
          disabled={isOnExitLoading}
        >
          Exit
        </Button>
      </Flex>
      <Divider />
    </header>
  );
}
